import { render, staticRenderFns } from "./GridChoice.vue?vue&type=template&id=a8d32fb0&"
import script from "./GridChoice.vue?vue&type=script&lang=js&"
export * from "./GridChoice.vue?vue&type=script&lang=js&"
import style0 from "./GridChoice.vue?vue&type=style&index=0&id=a8d32fb0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8d32fb0')) {
      api.createRecord('a8d32fb0', component.options)
    } else {
      api.reload('a8d32fb0', component.options)
    }
    module.hot.accept("./GridChoice.vue?vue&type=template&id=a8d32fb0&", function () {
      api.rerender('a8d32fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/element-view/GridChoice.vue"
export default component.exports